import { render, staticRenderFns } from "./XhInput.vue?vue&type=template&id=40edf7c6&scoped=true&"
import script from "./XhInput.vue?vue&type=script&lang=js&"
export * from "./XhInput.vue?vue&type=script&lang=js&"
import style0 from "./XhInput.vue?vue&type=style&index=0&id=40edf7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40edf7c6",
  null
  
)

component.options.__file = "XhInput.vue"
export default component.exports